export default __webpack_public_path__ + "static/media/ic_piyush_1.a1a3f5df.png";